import axiosInstance from '@/app/api/axiosInstance';
import { UserProfile } from '@/app/types/auth';

export const getCurrentUserInfo = async (): Promise<UserProfile> => {
    const response = await axiosInstance.get<UserProfile>('/users/me');
    return response.data;
};
